(ns ycweb.app.website.jobs.jobs
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.scroll :as scroll]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]))

(def ^:private bamboohr-url "https://yuppiechef.bamboohr.com/jobs/")

(defn- cloud-img [public-id w h alt]
  [:img.yc-simple-image.yc-simple-image--full.yc-simple-image--shadow.yc-simple-image--border
   {:src (str "https://res.cloudinary.com/yuppiechef/image/upload/w_" w ",f_auto/" public-id)
    :alt alt :width w :height h :loading "lazy"}])

(defn- seal-img [public-id alt]
  [:li.product-icons__item
   [:img.yc-simple-image.yc-simple-image--full.yc-simple-image--center
    {:src (str "https://res.cloudinary.com/yuppiechef/image/upload/f_auto/" public-id)
     :alt alt :width 104 :height 104}]])

(defn- cta-block [& [{:keys [margin-class] :or {margin-class "u-margin-top-20"}}]]
  [:div
   {:class (str "cta-block u-block-center u-max-width-640 " margin-class)}
   (headings/heading "Sound interesting?" {:type :h3 :size :tiny :center true})
   [:p.yc-paragraph.u-text-center "View our open job positions and apply online."]
   [:div.u-block-center.u-max-width-320.u-text-center
    (buttons/button-web "View Open Jobs"
      {:href bamboohr-url :style :dark :size :large :full true})]])

(rum/defc jobs-page < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        stats (cmn/curact action-atom :jobs-stats)
        staff (or (:staff stats) 350)
        products (or (:products stats) 7500)
        brands (or (:brands stats) 550)]
    (web-common/set-meta-title! "Jobs at Yuppiechef - SA's Premier Kitchen & Homeware Store")
    [:main#main-content.yc-page-content.yc-page-content--medium

     [:div.yc-section.yc-section--medium-underline
      [:div.yc-intro-text
       (headings/heading "Jobs at Yuppiechef" {:type :h1 :size :large :center true})
       [:p.yc-paragraph
        "What started as two good friends and only 32 products in a lounge in Cape Town, is now a "
        [:a.text-link.text-link--muted
         {:href "#js-jobs-life"
          :on-click #(scroll/scroll-to-id % "js-jobs-life")}
         (str "growing team of more than " staff)]
        (str " and over " products " products from " brands " of the world's leading brands. Today Yuppiechef is South Africa's premier kitchen and homeware store, and we're looking for talented people to join our team. ")
        [:a.text-link.text-link--muted {:href bamboohr-url} "View open jobs"]
        " or "
        [:a.text-link.text-link--muted
         {:href "#js-footer-newsletter"
          :on-click #(scroll/scroll-to-id % "js-footer-newsletter")}
         "sign up to our jobs newsletter."]
        " "]
     [:ul.product-icons.product-icons--center.group.u-margin-top-30
      (seal-img "pages/quality-seals/quality-seal-best-employer-award-light"
        "Yuppiechef won Employer of the Year at the 2017 Tech Awards")
      (seal-img "pages/quality-seals/quality-seal-years-trading-dark"
        "Yuppiechef has been operating since 2006")
      (seal-img "pages/quality-seals/quality-seal-retail-stores-light"
        "Yuppiechef is opening new retail stores")
      (seal-img "pages/quality-seals/quality-seal-growing-team-dark"
        "Yuppiechef's team is growing")]]
    (cta-block {:margin-class "u-margin-top-30"})]

   [:div#js-jobs-life.yc-section.yc-section--medium
    [:div.flex-grid-group
     [:figure.flex-grid-block.flex-grid-block--m-1-2
      [:div.flex-grid-content
       (cloud-img "pages/jobs/yuppiechef-willowbridge-store" 490 240
         "Yuppiechef's Willowbridge Store")]]
     [:figure.flex-grid-block.flex-grid-block--m-1-2
      [:div.flex-grid-content
       (cloud-img "pages/jobs/yuppiechef-gardens-store" 490 240
         "Yuppiechef's Gardens Store")]]]
    [:div.flex-grid-group
     [:figure.flex-grid-block.flex-grid-block--m-1-3
      [:div.flex-grid-content
       (cloud-img "pages/jobs/yuppiechef-team-shot" 490 320
         "The Yuppiechef Team with our Best Employer 2017 Award")]]
     [:figure.flex-grid-block.flex-grid-block--t-1-2.flex-grid-block--m-1-3
      [:div.flex-grid-content
       (cloud-img "pages/jobs/yuppiechef-sinjin-and-thina" 490 320
         "Sinjin and Thina making coffee at Yuppiechef")]]
     [:figure.flex-grid-block.flex-grid-block--t-1-2.flex-grid-block--m-1-3
      [:div.flex-grid-content
       (cloud-img "pages/jobs/yuppiechef-cayla-and-wade" 490 320
         "Cayla and Wade at Yuppiechef Gardens")]]]
    [:div.flex-grid-group
     [:figure.flex-grid-block.flex-grid-block--t-1-2.flex-grid-block--m-1-4
      [:div.flex-grid-content
       (cloud-img "pages/jobs/yuppiechef-stephen" 320 320
         "Stephen Isaacs at Yuppiechef")]]
     [:figure.flex-grid-block.flex-grid-block--t-1-2.flex-grid-block--m-1-4
      [:div.flex-grid-content
       (cloud-img "pages/jobs/yuppiechef-luyanda" 320 320
         "Luyanda at Yuppiechef")]]
     [:figure.flex-grid-block.flex-grid-block--t-1-2.flex-grid-block--m-1-4
      [:div.flex-grid-content
       (cloud-img "pages/jobs/yuppiechef-noel" 320 320
         "Noel Ross-Gillespie at Yuppiechef")]]
     [:figure.flex-grid-block.flex-grid-block--t-1-2.flex-grid-block--m-1-4
      [:div.flex-grid-content
       (cloud-img "pages/jobs/yuppiechef-marly-keenan-chadwin" 320 320
         "The Yuppiechef team making pancakes")]]]
    [:div.flex-grid-group
     [:figure.flex-grid-block.flex-grid-block--m-1-2
      [:div.flex-grid-content
       (cloud-img "pages/jobs/yuppiechef-tech-team" 490 240
         "Yuppiechef's Tech Team")]]
     [:figure.flex-grid-block.flex-grid-block--m-1-2
      [:div.flex-grid-content
       (cloud-img "pages/jobs/yuppiechef-gardens-team" 490 240
         "Yuppiechef's Gardens Team")]]]]

   [:div.yc-section.yc-section--medium
    [:aside.pinned-review
     [:p.pinned-review__quote
      "One gets the feeling that people here don't work for Yuppiechef. They are Yuppiechef."]
     [:small.pinned-review__author
      "— Ian Young, MD of Saatchi & Saatchi on a visit to Yuppiechef HQ in 2013"]]]

   [:div.yc-section.yc-section--medium-underline
    (cta-block)]]))

(defmethod flow/render-screen :web.jobs [app-atom _]
  (website/screen-wrapper app-atom
    (jobs-page app-atom)
    {:banner-type "Footer Ads" :banner-limit 4}))

(defmethod t/transition-open :web.jobs [app-atom _ _]
  (toaster/open-overlay app-atom :web.jobs)
  (comms/ajax-get :web.jobs/stats {}))

(defmethod comms/receive :web.jobs/stats [app-atom e]
  (swap! (cmn/action-cursor app-atom) assoc :jobs-stats e)
  (toaster/close-overlay app-atom :web.jobs))
